import { z } from "zod";

export const phoneNumberValidation = z
    .string()
    .trim()
    .refine((val) => val.length > 0, { message: "Phone number is required" })
    .refine((val) => !val.startsWith("0"), { message: "Phone number cannot start with 0" })
    .refine((val) => /^\d+$/.test(val), { message: "Phone number must contain digits only" })
    .refine((val) => val.length === 10 || val.length === 11, {
        message: "Phone number must be 10 or 11 digits",
    })
    .refine((val) => !/^\s/.test(val), { message: "Phone number cannot start with a space" }); // Check for leading spaces

export const emailValidation = z
    .string()
    .trim() // Remove leading/trailing spaces
    .email("Invalid email address") // Built-in email validation
    .regex(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format");

/**
 * validation is as per KYC > PAN > Name field.
 */
export const nameValidation = z
    .string()
    .trim() // Remove leading/trailing spaces
    .min(1, { message: "Full name is required" })
    // .min(6, { message: "Name must be at least 6 characters long" })
    .max(100, { message: "Full name must be less than 100 characters" })
    .regex(/^[A-Za-z][A-Za-z0-9\s'&.!()-]*$/, {
        message: "Name must start with a letter and can contain letters, numbers, spaces, and select special characters ('&.!(),*-)",
    })
    .refine((val) => !/^\s|\s$/.test(val), {
        message: "Name cannot have leading or trailing spaces",
    });
